(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  function activateTab(tabsRoot, tabName) {
    if (!tabsRoot) return;

    var tabButtons = tabsRoot.querySelectorAll('[data-nr-tab]');
    var panels = tabsRoot.querySelectorAll('[data-nr-panel]');

    tabButtons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-nr-tab') === tabName;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var isTarget = panel.getAttribute('data-nr-panel') === tabName;
      panel.classList.toggle('is-active', isTarget);
      if (isTarget) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function initReviewsPreview() {
    document.querySelectorAll('[data-nr-reviews-preview]').forEach(function (preview) {
      var cards = Array.from(preview.querySelectorAll('[data-nr-reviews-preview-card]'));
      if (!cards.length) return;

      cards
        .sort(function (a, b) {
          return (b.dataset.reviewDate || '').localeCompare(a.dataset.reviewDate || '');
        })
        .forEach(function (card) {
          preview.appendChild(card);
        });

      cards.forEach(function (card, index) {
        card.hidden = index >= 2;
      });
    });
  }

  function scrollToTarget(target) {
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* Tab switching */
  var tabsRoot = document.querySelector('[data-nr-product-info-tabs]');
  if (tabsRoot) {
    var tabButtons = tabsRoot.querySelectorAll('[data-nr-tab]');

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(tabsRoot, btn.getAttribute('data-nr-tab'));
      });
    });

    initReviewsPreview();
  }

  document.querySelectorAll('[data-nr-open-reviews-tab]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var tabsEl = document.getElementById('nr-product-info-tabs');
      scrollToTarget(tabsEl);
      activateTab(tabsRoot, 'reviews');
    });
  });

  document.querySelectorAll('[data-nr-reviews-view-more]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToTarget(document.getElementById('nr-reviews'));
    });
  });

  /* Qty stepper — bind events to server-rendered markup */
  function initQtyStepper() {
    document.querySelectorAll('.product-information [data-nr-qty-stepper]').forEach(function (stepper) {
      if (stepper.dataset.nrQtyStepperInit) return;
      stepper.dataset.nrQtyStepperInit = 'true';

      var formButtons = stepper.closest('.product-form-buttons');
      if (!formButtons) return;

      var wrapper = formButtons.querySelector('.quantity-selector-wrapper');
      if (!wrapper) return;

      var input = wrapper.querySelector('input[name="quantity"]');
      if (!input) return;

      if (wrapper.querySelector('.price-per-item')) return;

      var min = parseInt(stepper.dataset.nrQtyMin || input.getAttribute('min') || input.dataset.min || '1', 10);
      var max = parseInt(stepper.dataset.nrQtyMax || input.getAttribute('max') || '3', 10);
      if (isNaN(max) || max > 3) max = 3;
      if (max < min) max = min;

      var minusBtn = stepper.querySelector('.nr-qty-stepper__btn--minus');
      var plusBtn = stepper.querySelector('.nr-qty-stepper__btn--plus');
      var valueEl = stepper.querySelector('.nr-qty-stepper__value');
      if (!minusBtn || !plusBtn || !valueEl) return;

      function syncDisplay() {
        var val = parseInt(input.value, 10) || min;
        valueEl.textContent = String(val);
        minusBtn.disabled = val <= min;
        plusBtn.disabled = val >= max;
      }

      minusBtn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || min;
        if (val <= min) return;
        input.value = String(val - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncDisplay();
      });

      plusBtn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || min;
        if (val >= max) return;
        input.value = String(val + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncDisplay();
      });

      input.addEventListener('change', syncDisplay);

      syncDisplay();
    });
  }

  initQtyStepper();

  document.addEventListener('shopify:section:load', initQtyStepper);
  document.addEventListener('variant:update', function () {
    requestAnimationFrame(initQtyStepper);
  });
})();
